import { SimpleInput } from "@axismaxlife/unified-ui-components-library";
import { useState } from "react";
import { String } from "../constants/Strings";

const toDigits = (raw) => `${raw ?? ""}`.replace(/[^0-9]/g, "").slice(0, 2);

export const YearInput = ({
  name,
  label,
  value,
  onChange,
  unit = String.yearsShort,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const digits = toDigits(value);

  return (
    <SimpleInput
      name={name}
      type="text"
      inputMode="numeric"
      width="100%"
      label={label}
      placeholder={label}
      value={isFocused || !digits ? digits : `${digits} ${unit}`}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onChange={(e) => onChange(toDigits(e.target.value))}
    />
  );
};
